import { render, staticRenderFns } from "./VisualizarProfissionalDialog.vue?vue&type=template&id=13f0dd4d&scoped=true"
import script from "./VisualizarProfissionalDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarProfissionalDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarProfissionalDialog.vue?vue&type=style&index=0&id=13f0dd4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0dd4d",
  null
  
)

export default component.exports